import React from "react";
import "./viewByType.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchCategoryProducts } from "../../../../features/product/productThunks";

import ImageGym from "../../../../assets/images/gym-image.svg";
import ImageParty from "../../../../assets/images/party-image.svg";
import ImageFormal from "../../../../assets/images/formal-image.svg";
import ImageCasual from "../../../../assets/images/casual-image.svg";
import { clearProducts } from "../../../../features/product/productSlice";

export default function ViewByTypeSection() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCategoryClick = async (category) => {
    try {
      dispatch(clearProducts());
      navigate("/brands-products", {
        state: {
          endPoint: `category?category=${category}`,
        },
      });
    } catch (error) {
      console.error("Error fetching category products:", error);
    }
  };

  return (
    <div className="viewByType-container">
      <p className="viewByType-title">BROWSE BY</p>
      <p className="viewByType-title">DRESS STYLE</p>

      <div className="viewByType-row">
        <img
          src={ImageParty}
          className="viewByType-image"
          alt="Party dress style – worldwide shipping online shopping"
          onClick={() => handleCategoryClick("Party")}
        />

        <img
          src={ImageGym}
          className="viewByType-image"
          alt="Gym dress style – activewear"
          onClick={() => handleCategoryClick("Gym")}
        />
      </div>
      <div className="viewByType-row">
        <img
          src={ImageCasual}
          className="viewByType-image"
          alt="Casual dress style – everyday fashion"
          onClick={() => handleCategoryClick("Casual")}
        />

        <img
          src={ImageFormal}
          className="viewByType-image"
          alt="Formal dress style – elegant outfit"
          onClick={() => handleCategoryClick("Formal")}
        />
      </div>
    </div>
  );
}
